import { Button } from 'components/buttons/Button/Button';
import { ReactComponent as SVG } from 'images/card-decor.svg';

const ProductCard = ({ index, title, text, img, logo }) => {
    const number = String(index + 1).padStart(2, '0');

    return (
        <div className={`product-card ${index % 2 !== 0 ? 'product-card--reverse' : ''}`}>
            <div className="product-card__image" data-index={'• ' + number}>
                <SVG />
                <img src={img} alt="product-item" className="product-card__image-bg" />
                {logo && (
                    <div className="product-card__image-logo">
                        <img src={logo} alt="product-logo" />
                    </div>
                )}
            </div>
            <div className="product-card__content">
                <h3>{title}</h3>
                <p className="body1">{text}</p>
                <Button type="learn-more-arrow">View product</Button>
            </div>
        </div>
    );
};

export default ProductCard;
